   <div class="signUpComponent" [ngClass]="signUpState">
      <fieldset class="fieldset withoutM fname" [ngClass]="inputClasses['first_name']">
        <legend class="legend">{{ 'first_name' | translate }} *</legend>
        <ion-icon class="bioicon" src="assets/svg/suser.svg"></ion-icon>
        <input type="text" name="first_name" class="app-input" autocomplete="off" [(ngModel)]="signUpForm.name" [placeholder]="'first_name' | translate" />
      </fieldset>
      
      <fieldset class="fieldset lname" [ngClass]="inputClasses['last_name']">
        <legend class="legend">{{ 'last_name' | translate }} *</legend>
        <ion-icon class="bioicon" src="assets/svg/suser.svg"></ion-icon>
        <input type="text" name="last_name" class="app-input" autocomplete="off" [(ngModel)]="signUpForm.last_name" [placeholder]="'last_name' | translate" />
      </fieldset>

      <fieldset class="fieldset phonenumberBox" [ngClass]="inputClasses['phone']">
        <legend class="legend">{{ 'mobile_number' | translate }} *</legend>
        <ion-icon class="bioicon" src="assets/svg/device.svg"></ion-icon>
        <input type="tel" name="phone" [(ngModel)]="signUpForm.phone" [placeholder]="'enter_your_mobile_number' | translate" [attr.maxlength]="userPhoneAllowedDigit" class="app-input"
          inputmode="numeric" autocomplete="tel" (input)="onPhoneInput($event)" />
      </fieldset>

      <fieldset class="fieldset emailBox" [ngClass]="inputClasses['email']">
        <legend class="legend">{{ 'email' | translate }} *</legend>
        <ion-icon class="bioicon" src="assets/svg/e-mail.svg"></ion-icon>
        <input id="signupEmailInput" type="text" name="email" class="app-input" autocomplete="off" [(ngModel)]="signUpForm.email" [placeholder]="'email' | translate" />
      </fieldset>

      <input type="hidden" name="areasOrRegionId" [(ngModel)]="signUpForm.areasOrRegionId" />

      <fieldset class="fieldset areaBox" [ngClass]="inputClasses['area']" (click)="openAreaModal()">
        <legend class="legend">{{ 'area' | translate }}</legend>
        <ion-icon class="bioicon" src="assets/svg/mapmain.svg"></ion-icon>
        <input id="signupAreaInput" type="text" class="app-input disabledInput" [value]="areasOrRegionName || ''" [readonly]="true" [placeholder]="'area' | translate" />
        <ion-icon class="bioicon" src="assets/svg/chevron-down.svg"></ion-icon>
      </fieldset>

      <ng-container *ngIf="isReferralEnabled">
        <fieldset class="fieldset">
          <legend class="legend">{{ 'referral_code' | translate }}</legend>
          <ion-icon class="bioicon" src="assets/svg/fa-star.svg"></ion-icon>
          <input id="signupReferralInput" type="text" name="referral_code" class="app-input" [(ngModel)]="signUpForm.referral_code" [placeholder]="'Enter Code Here' | translate" />
        </fieldset>
      </ng-container>

      <fieldset class="fieldset" [ngClass]="inputClasses['password']">
        <legend class="legend">{{ 'new_password' | translate }}</legend>
        <ion-icon class="bioicon" src="assets/svg/password.svg"></ion-icon>
        <input id="signupPasswordInput" name="password" [type]="passwordInputType" class="app-input" [(ngModel)]="signUpForm.password" [placeholder]="'create_your_new_password' | translate" />
        <ion-icon (click)="togglePasswordVisibility()" class="eye-pwd" [src]="!showPasswordFlag ? '../../../../assets/svg/eye-off.svg' : '../../assets/svg/eye.svg'"></ion-icon>
      </fieldset>

      <div class="termsBox">
        <ion-checkbox [(ngModel)]="signUpForm.TcChecked" name="TcChecked" mode="ios" class="termsCheckbox"></ion-checkbox>
        <ion-label>{{ 'agree' | translate }}</ion-label>
        <ion-label class="termsLink" (click)="openTermsAndConditionsModal()">
          {{ 'terms_and_conditions' | translate }}
        </ion-label>
      </div>

      <input type="hidden" name="country_iso_code" [(ngModel)]="signUpForm.country_iso_code" class="hidden-input" />

      <app-button [height]="'5vh'" [width]="'70'" [borderRad]="'30'" (buttonClick)="onSubmitSignUp()" [color]="'primary'" [opacity]="[9,8,9]">
        {{'signup' | translate}}
      </app-button>
    </div>


      <div class="popLoadingBack" *ngIf="loading">
    <div class="popLoading">

        <div class="popLoader">
          <div class="loader"></div>
    </div>
</div>